import type { ACLType } from 'backend/types'
import type { SalesforceProjectMemberTypeId } from 'shared'
import { SALESFORCE_PROJECT_MEMBER_TYPE_IDS } from 'shared'

export interface OpportunityTab {
  key: string
  label: string
  description: string
  salesforceProjectMemberTypeId?: SalesforceProjectMemberTypeId
  isAll?: boolean // 全案件取得モード
  // 無効化条件（権限がない場合にtrue）
  isDisabled: (user: {
    isCaptain?: boolean
    isServiceManager?: boolean
    isProjectManager?: boolean
    isSalesMember?: boolean
    acl?: ACLType
  }) => boolean
}

export const opportunityTabs: OpportunityTab[] = [
  {
    key: 'owner',
    label: 'OWNER',
    description: '自身が起票したオポチュニティ一覧を表示します',
    isDisabled: () => false, // 常に有効
  },
  {
    key: 'captain',
    label: 'CAPTAIN',
    description: 'キャプテンとして担当している案件のオポチュニティ一覧を表示します',
    salesforceProjectMemberTypeId: SALESFORCE_PROJECT_MEMBER_TYPE_IDS.CAPTAIN,
    isDisabled: (user) => !user.isCaptain,
  },
  {
    key: 'smg',
    label: 'SMG',
    description: 'サービスマネージャーとして担当している案件のオポチュニティ一覧を表示します',
    salesforceProjectMemberTypeId: SALESFORCE_PROJECT_MEMBER_TYPE_IDS.SERVICE_MANAGER,
    isDisabled: (user) => !user.isServiceManager,
  },
  {
    key: 'pm',
    label: 'PM',
    description: 'プロジェクトマネージャーとして担当している案件のオポチュニティ一覧を表示します',
    salesforceProjectMemberTypeId: SALESFORCE_PROJECT_MEMBER_TYPE_IDS.PROJECT_MANAGER,
    isDisabled: (user) => !user.isProjectManager,
  },
  {
    key: 'sales',
    label: 'SALES',
    description: '営業担当として担当している案件のオポチュニティ一覧を表示します',
    salesforceProjectMemberTypeId: SALESFORCE_PROJECT_MEMBER_TYPE_IDS.SALES_MEMBER,
    isDisabled: (user) => !user.isSalesMember,
  },
  {
    key: 'all',
    label: 'ALL',
    description: '特権（SMG or 営業 or 管理者）ですべてのオポチュニティを表示します',
    isAll: true,
    isDisabled: (user) =>
      !(
        user.acl?.administrator === true ||
        user.acl?.opportunity?.privileged === true ||
        user.isServiceManager === true ||
        user.isSalesMember === true
      ), // 特権ユーザーでない場合は無効
  },
]

/**
 * デフォルトタブキーを取得
 * キャプテンで作成権限がある場合は 'captain'、それ以外は 'owner'
 */
export function getDefaultTabKey(user: { isCaptain?: boolean; acl?: ACLType }): string {
  if (user.isCaptain && user.acl?.opportunity?.create) {
    return 'captain'
  }
  return 'owner'
}
